import Vue from 'vue';
import Vuex from 'vuex';
import { FeathersVuex, models } from '../feathers-client';

/** Add/replace client's components */
import komacutStores from '../_komacut/store';

Vue.use(Vuex);
Vue.use(FeathersVuex);

const requireModule = require.context('./', false, /.js$/);
const appModules = requireModule.keys().filter(path => path !== './index.js').map(path => requireModule(path).default);

const modules = {
  ..._.reduce(appModules, (acc, mod) => ({ ...acc, ...mod.store }), {}),

  /** Add/replace client's modules */
  ...komacutStores.modules,
};

const plugins = [
  ...appModules.map(mod => mod.plugin),

  /** Add/replace client's plugins */
  ...komacutStores.plugins,
];

const store = new Vuex.Store({
  modules,
  plugins,
});

const resetStore = name => {
  const model = models.api.byServicePath[name];
  if (model.namespace) {
    model.store.commit(`${model.namespace}/clearAll`);
  }
};

const resetStores = () => {
  store.commit('app/clearAll');
  store.commit('auth/clearAll');
  // store.commit('tabs/clearAll');

  for (const name of _.keys(models.api.byServicePath)) {
    resetStore(name);
  }
};

export {
  modules,
  plugins,
  resetStore,
  resetStores,
};

export default store;
